module.exports = __webpack_public_path__ + "img/24.0db6e41c.svg";